// Mirrors com.fivtyonetrips.colab.*.dto.AgencyUserDTO from 51trips-colab-api
// (GET/POST /agencies/{agencyId}/users*) — see "Gestión de Usuarios de Agencia"
// spec for the full contract.

export type AgencyUserAuthMethod = 'password' | 'phone' | 'magicLink'

export type AgencyUser = {
    uid: string
    agencyId: string
    email: string | null
    phoneNumber: string | null
    displayName: string | null
    // A user can have more than one linked at once — password and magic link
    // share the same email; phone is independent of both.
    authMethods: AgencyUserAuthMethod[]
    disabled: boolean
    createdAt: number | null // epoch millis
}

export const ALL_AGENCY_USER_AUTH_METHODS: AgencyUserAuthMethod[] = ['password', 'phone', 'magicLink']

export type CreateAgencyUserPasswordRequest = {
    email: string
    password: string
    displayName?: string
}

export type CreateAgencyUserPhoneRequest = {
    phoneNumber: string // E.164, e.g. +34600000000
    displayName?: string
}

export type GenerateAgencyMagicLinkRequest = {
    email: string
    displayName?: string
    // Must be in the Firebase project's "Authorized domains"; falls back to the
    // backend's own domain (app.base.url) when omitted, which is rarely what's
    // wanted for an end-user login.
    continueUrl?: string
}

// 401/404/500 error body — the other shape (400, field validation) is a flat
// { [field]: message } map instead, no envelope.
export type MessageErrorDTO = {
    errorKey: string
    message: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params?: Record<string, any>
}
